import {BufferGeometry, Group, Mesh, MeshPhysicalMaterial, Object3D} from "three";
import {ResourceManagerService} from "../service/resource.manager.service";
import {MaterialService} from "../service/material/material.service";
import {CustomMaterialType} from "../service/material/custom-material-type.enum";
import {extractCombinedGeometry} from "../util/extract-geometries";
import {dispose3dResource} from "../util/dispose-object";


export class LamellaObject extends Group {

    private lamellaMaterial: MeshPhysicalMaterial | null = null;

    private model: Object3D | undefined;

    constructor(
        private data : any,
        private resourceManager: ResourceManagerService,
        private materialService: MaterialService
    ) {
        super()
        this.name = `LamellaObject - ${data.name}`;
    }

    public async init() {
        this.receiveShadow = true;
        this.castShadow = true;

        // Asetetaan polku (tai ota suoraan data.modelPath)
        const modelPath = "/api/storage/view/"+this.data.object3dUrl  //"/assets/3d-files/12798.obj";
        return this.loadModel(modelPath)
    }

    private async loadModel(path: string): Promise<void> {

        // Määritellään materiaalin tyyppi datan perusteella
        const isPowder = this.data!.powderCoated === true;

        const materialType = isPowder
            ? CustomMaterialType.PowderCoated
            : CustomMaterialType.AnodizedAluminum;

        return this.resourceManager.loadResource(path, "obj", this.uuid, true)
            .then((model) => {

        if (model instanceof Object3D) {
            this.model = model;
            this.applyPositionAndRotationCorrection(model);

            this.add(model);
            model.castShadow = this.castShadow;
            model.receiveShadow = this.receiveShadow;

            this.model = model;
            //this.applyMaterial(model);
                } else {
                    console.warn(`Model ${path} not loaded correctly`);
                }

                /*this.materialService.getMaterial(materialType).then((material) => {
                    // Käydään mallin lapset läpi ja asetetaan materiaali
                    //model.traverse((child) => { if (child instanceof Mesh) { child.material = lamellaMaterial; } });
                })*/


            })
            .catch(console.error);
    }

    private applyPositionAndRotationCorrection(model : Object3D) {
        model.quaternion.copy(this.data.offsetRotation);
        model.position.copy(this.data.offsetPosition);
    }

    private async applyMaterial(model: Object3D): Promise<void> {
        try {
            // Esim. jos haluat aina anodisoitua alumiinia:
            // const lamellaMaterial = await this.materialService.getMaterial(CustomMaterialType.AnodizedAluminum);

            // Tai tarkistamalla data-lipusta kumpi materiaali:
            const isPowder = this.data?.powderCoated === true;
            const materialType = isPowder
                ? CustomMaterialType.PowderCoated
                : CustomMaterialType.AnodizedAluminum;

            const lamellaMaterial = await this.materialService.getMaterial(materialType);

            model.traverse((child) => {
                if (child instanceof Mesh) {
                    // Voit halutessasi tehdä myös child.material = lamellaMaterial.clone()
                    // jos jokainen mesh halutaan omalla kloonilla.
                    child.material = lamellaMaterial;
                }
            });

        } catch (error) {
            console.error('Virhe materiaalin haussa: ', error);
        }

    }

    public destroy() {

        this.lamellaMaterial = null;
        this.model = undefined;

        // Poistetaan viitteet palveluihin (ei pakollista mutta auttaa GC:ssä)
        (this.resourceManager as any) = null;
        (this.materialService as any) = null;

        dispose3dResource(this);

    }

    get geometry(): BufferGeometry {
        return !this.model ? undefined : extractCombinedGeometry(this.model);
    }

}